import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/company/:companyId/',
    name: 'company',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "company" */ './views/company.vue')
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.companyId = parseInt(routeTo.params.companyId)
        window.localStorage.setItem(
          'LAST_VISITED_COMPANY_ID',
          routeTo.params.companyId
        )
        routeTo.meta.tmp.routeFrom = ''
        if (routeFrom.name === 'login' || routeFrom === 'verify-phone') {
          routeTo.meta.tmp.routeFrom = 'login'
        }
        routeTo.meta.tmp.companyId = parseInt(routeTo.params.companyId)
        if (
          store.getters['auth/canViewCompany']({
            companyId: routeTo.meta.tmp.companyId,
          })
        ) {
          handleRoute()
        } else {
          next({ name: '404', params: { resource: 'Company' } })
        }
        function handleRoute() {
          store
            .dispatch('companies/fetchStatusUpdates', {
              companyId: routeTo.params.companyId,
              pageNr: 1,
            })
            .then((posts) => {
              routeTo.meta.tmp.postsCount = posts.length

              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'Company' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      statusUpdates: route.meta.tmp.statusUpdates,
      companyId: parseInt(route.meta.tmp.companyId, 10),
      routeFrom: route.meta.tmp.routeFrom,
      postsCount: route.meta.tmp.postsCount,
      // showDefaultCompanyPicker: route.meta.tmp.showDefaultCompanyPicker,
    }),
  },
  {
    path: '/company/:companyId/profile/viewhubs',
    name: 'profile-my-hubs',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "company" */ './views/company.vue')
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.companyId = parseInt(routeTo.params.companyId)
        routeTo.meta.tmp.showUserProfile = true
        window.localStorage.setItem(
          'LAST_VISITED_COMPANY_ID',
          routeTo.params.companyId
        )
        routeTo.meta.tmp.routeFrom = ''
        if (routeFrom.name === 'login' || routeFrom === 'verify-phone') {
          routeTo.meta.tmp.routeFrom = 'login'
        }
        routeTo.meta.tmp.companyId = parseInt(routeTo.params.companyId)
        if (
          store.getters['auth/canViewCompany']({
            companyId: routeTo.meta.tmp.companyId,
          })
        ) {
          handleRoute()
        } else {
          next({ name: '404', params: { resource: 'Company' } })
        }
        function handleRoute() {
          store
            .dispatch('companies/fetchStatusUpdates', {
              companyId: routeTo.params.companyId,
              pageNr: 1,
            })
            .then(() => {
              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'Company' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      statusUpdates: route.meta.tmp.statusUpdates,
      companyId: parseInt(route.meta.tmp.companyId, 10),
      routeFrom: route.meta.tmp.routeFrom,
    }),
  },
  {
    path: '/company/:companyId/group/:groupId',
    name: 'group',
    component: () =>
      lazyLoadView(import(/* webpackChunkName: "group" */ './views/group.vue')),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.companyId = parseInt(routeTo.params.companyId)
        routeTo.meta.tmp.groupId = parseInt(routeTo.params.groupId)
        handleRoute()
        function handleRoute() {
          store
            .dispatch('companies/fetchStatusUpdatesGroup', {
              groupId: routeTo.params.groupId,
              pageNr: 1,
            })
            .then((posts) => {
              routeTo.meta.tmp.postsCount = posts.length

              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'Group' } })
            })
        }
      },
      parentName: 'company',
    },
    props: (route) => ({
      statusUpdates: route.meta.tmp.statusUpdates,
      companyId: parseInt(route.meta.tmp.companyId, 10),
      groupId: parseInt(route.meta.tmp.groupId, 10),
      postsCount: route.meta.tmp.postsCount,
    }),
  },
]
